/**
 * Catalogue Service API Spec
 * Catalogue service to retrieve values from Banesco DR
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://github.com/Backbase/backbase-openapi-tools).
 * https://github.com/Backbase/backbase-openapi-tools
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

import { CatalogItem } from '../model/models';

import { EXCHANGE_RATES_BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { ExchangeRatesConfiguration } from '../configuration';

export interface GetCatalogByIdRequestParams {
  /** Id of the catalogue */
  ['id']?: string;
}

export interface GetCatalogByGroupIdRequestParams {
  /** Id of the catalogue */
  ['groupId']?: string;
}

//cx.bancadigitaldev.banesco.com.do/api/catalogue-integration-service/v2/catalogue?id=1

@Injectable({
  providedIn: 'root',
})
export class CataloguesHttpService {
  protected basePath = '/api/catalogue-integration-service';
  public defaultHeaders = new HttpHeaders();
  public configuration = new ExchangeRatesConfiguration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(EXCHANGE_RATES_BASE_PATH) basePath: string,
    @Optional() configuration: ExchangeRatesConfiguration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Returns items from catalog in the form of a key-value pair
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCatalogById(
    requestParameters: GetCatalogByIdRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<Array<CatalogItem>>;
  public getCatalogById(
    requestParameters: GetCatalogByIdRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<Array<CatalogItem>>>;
  public getCatalogById(
    requestParameters: GetCatalogByIdRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<Array<CatalogItem>>>;
  public getCatalogById(
    requestParameters: GetCatalogByIdRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    const _id = requestParameters['id'];
    if (_id === null || _id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getCatalogById.');
    }

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (_id !== undefined && _id !== null) {
      queryParameters = this.addToHttpParams(queryParameters, <any>_id, 'id');
    }

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<CatalogItem>>(`${this.configuration.basePath}/v2/catalogue`, {
      params: queryParameters,
      responseType: <any>responseType,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  public getCatalogByIdUrl(requestParameters: GetCatalogByIdRequestParams): string {
    const _id = requestParameters['id'];
    if (_id === null || _id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getCatalogById.');
    }
    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (_id !== undefined && _id !== null) {
      queryParameters = this.addToHttpParams(queryParameters, <any>_id, 'id');
    }
    const queryString = queryParameters.toString();
    return `${this.configuration.basePath}/v2/catalogue${queryString ? `?${queryString}` : ''}`;
  }

  /**
   * Returns items from catalog in the form of a key-value pair
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCatalogByGroupId(
    requestParameters: GetCatalogByGroupIdRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<Array<CatalogItem>>;
  public getCatalogByGroupId(
    requestParameters: GetCatalogByGroupIdRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpResponse<Array<CatalogItem>>>;
  public getCatalogByGroupId(
    requestParameters: GetCatalogByGroupIdRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<HttpEvent<Array<CatalogItem>>>;
  public getCatalogByGroupId(
    requestParameters: GetCatalogByGroupIdRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' },
  ): Observable<any> {
    const _id = requestParameters['groupId'];
    if (_id === null || _id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getCatalogByGroupId.');
    }

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (_id !== undefined && _id !== null) {
      queryParameters = this.addToHttpParams(queryParameters, <any>_id, 'groupId');
    }

    let headers = this.defaultHeaders;

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    let responseType: 'text' | 'json' = 'json';
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
      responseType = 'text';
    }

    return this.httpClient.get<Array<CatalogItem>>(`${this.configuration.basePath}/v2/catalogueByGroup`, {
      params: queryParameters,
      responseType: <any>responseType,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  public getCatalogByGroupIdUrl(requestParameters: GetCatalogByGroupIdRequestParams): string {
    const _id = requestParameters['groupId'];
    if (_id === null || _id === undefined) {
      throw new Error('Required parameter group id was null or undefined when calling getCatalogByGroupId.');
    }
    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (_id !== undefined && _id !== null) {
      queryParameters = this.addToHttpParams(queryParameters, <any>_id, 'groupId');
    }
    const queryString = queryParameters.toString();
    return `${this.configuration.basePath}/v2/catalogueByGroup${queryString ? `?${queryString}` : ''}`;
  }
}
